import React, { FC, useRef, useState } from 'react';
import CheckBox from 'src/components/atoms/CheckBox';
import DefLabel from 'src/components/atoms/label/LabelContnet';
import IconButton from 'src/components/atoms/buttons/IconButton';
import FamilySet from 'src/components/organisms/template/StepA/MyFamilyInfo/FamilySet';
import { familyDataStore } from 'src/store/familyInfo';
import { confirmModalViewStore } from 'src/store/modal';
import { familyType } from 'src/static/typeCode';
import { fetchDeleteFamilyData } from 'src/fetch/stepA';
import { getResidentId, makeTestRRN } from 'src/utils/charSet';
import {
  isResidentTaxpayer,
  isElderlyDeductionApplied,
  isHandyDeductionApplied,
  isChildTaxDeductionApplied,
  isBirthOrAdoptDeductionApplied,
} from 'src/utils/familyDeduction';
import { getMemberInfo } from 'src/utils/common';
import { useQueryClient } from '@tanstack/react-query';
import { errorModalViewStore, loadingModalViewStore } from 'src/store/modal';
import { contentModalViewStore } from 'src/store/modal';
import './style.scss';

interface Props {
  familyData: any;
  type?: string;
  addEvent?: () => void;
}
const FamilyCard: FC<Props> = ({ familyData, type, addEvent }) => {
  const userInfoData: any = getMemberInfo();
  const queryClient = useQueryClient();
  const errorModalState = errorModalViewStore((state: any) => state.set);
  const loadingState = loadingModalViewStore((state: any) => state.set);
  const setConfirmModalState = confirmModalViewStore((state: any) => state.set);
  const closeModalState = confirmModalViewStore((state: any) => state.close);

  const familyInfoDataParam = familyDataStore((state: any) => state.param);
  const familyInfoDataBindParam = familyDataStore((state: any) => state.bindParam);
  // const familyPayload = familyDataStore((state: any) => state.payload);
  // const familyPayloadBind = familyDataStore((state: any) => state.bindPayload);
  const setContentModalState = contentModalViewStore((state: any) => state.set);

  // FamilySet/FamilyDescription과 동일한 규칙으로 경로우대/장애인/자녀세액/출산입양공제 재계산
  const residentTaxpayer = isResidentTaxpayer(userInfoData);
  const isOldApplied = isElderlyDeductionApplied(
    familyData,
    userInfoData.acct_year,
    residentTaxpayer
  );
  const isHandyApplied = isHandyDeductionApplied(familyData);
  const isChildDeductionApplied = isChildTaxDeductionApplied(
    familyData,
    userInfoData.acct_year,
    residentTaxpayer
  );
  const isBirthOrAdoptApplied = isBirthOrAdoptDeductionApplied(familyData, userInfoData.acct_year);

  // console.log('familyData:::', familyData);
  // 690101-1000007
  // 490101-1000001

  const addClickEvt = (e: React.MouseEvent) => {
    if (addEvent) addEvent();
  };
  // DELETE
  const deleteEvt = () => {
    setConfirmModalState({
      active: '_active',
      content: (
        <div className="_title">
          <div className="_main">
            <span className="_group">({familyType(familyData.family_type || '')})</span>{' '}
            {familyData.name}
          </div>
          <div className="_sub">해당 내용을 삭제하시겠습니까?</div>
        </div>
      ),
      cancleEvt: () => {
        closeModalState({ content: null, active: '' });
      },
      confirmEvt: () => {
        const param: any = userInfoData;
        param.family_seqid = familyData.family_seqid;

        fetchDeleteFamilyData(param, queryClient, errorModalState, loadingState, () => {
          closeModalState({ content: null, active: '' });
          const initialSeq = familyInfoDataParam.initialSeq || 0;
          familyInfoDataBindParam({ initialSeq: initialSeq + 1 });
        });
      },
    });
  };
  // UPDATE
  const viewEvt = () => {
    setContentModalState({
      active: '_active',
      title: `${familyData.name}`,
      content: <FamilySet viewType="view" formData={familyData} />,
      styleDef: { width: '950px' },
    });
  };

  if (type === 'add') {
    return (
      <div className="_family_card_box_n_div" onClick={e => addClickEvt(e)}>
        <div className="_box _add">
          <div className="_add_btn_div">
            <div className="_icon">
              <i className="ri-user-add-fill"></i>
            </div>
            <div className="_desc">부양가족 추가</div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="_family_card_box_n_div">
      <div className="_box">
        <div className="_btn_div">
          <div className="_btn">
            <IconButton
              icon="ri-file-text-line"
              // icon="ri-edit-box-line"
              clickEvent={viewEvt}
              type="type4"
              styleDef={{
                width: '25px',
                height: '25px',
                fontSize: '14px',
              }}
            />
          </div>
          {familyData.family_type !== '0' ? (
            <div className="_btn">
              <IconButton
                icon="ri-delete-bin-2-line"
                clickEvent={deleteEvt}
                type="type2"
                styleDef={{
                  width: '25px',
                  height: '25px',
                  fontSize: '15px',
                }}
              />
            </div>
          ) : (
            ''
          )}
        </div>
        <div className="_row">
          <div className="_col_item _name">{familyData.name}</div>
        </div>
        <div className="_row">
          <div className="_col_item _tp1">{familyType(familyData.family_type || '')}</div>
        </div>
        <div className="_row">
          <div className="_col_item _tp2">{getResidentId(familyData.res_id)}</div>
        </div>
        <div className="_row _label">
          <div className={['_col_item', familyData.is_ele_deduct === 'Y' ? '_act' : ''].join(' ')}>
            <div className="_label">기본공제</div>
          </div>
          <div
            className={['_col_item', familyData.is_deduct_women === 'Y' ? '_act' : ''].join(' ')}
          >
            <div className="_label">부녀자</div>
          </div>
          <div
            className={['_col_item', familyData.is_deduct_single_parent === 'Y' ? '_act' : ''].join(
              ' '
            )}
          >
            <div className="_label">한부모</div>
          </div>
          <div className={['_col_item', isOldApplied ? '_act' : ''].join(' ')}>
            <div className="_label">경로우대</div>
          </div>
          <div className={['_col_item', isHandyApplied ? '_act' : ''].join(' ')}>
            <div className="_label">장애인 공제</div>
          </div>
          <div className={['_col_item', isChildDeductionApplied ? '_act' : ''].join(' ')}>
            <div className="_label">자녀세액</div>
          </div>
          <div className={['_col_item', isBirthOrAdoptApplied ? '_act' : ''].join(' ')}>
            <div className="_label">출산입양</div>
          </div>
          <div className={['_col_item', familyData.is_adopt === 'Y' ? '_act' : ''].join(' ')}>
            <div className="_label">입양</div>
          </div>
          <div
            className={['_col_item', familyData.is_hc_exception === 'Y' ? '_act' : ''].join(' ')}
          >
            <div className="_label">산정특례자</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FamilyCard;
